import { Reducer } from "redux";
import { produce } from "immer";

import { EMPTY_OBJECT } from "@multiweb/reactUtils";
import { IFetchingState, ISetFetchingAction } from "./types";

export const reducer: Reducer<IFetchingState> = (state = EMPTY_OBJECT, action) =>
    produce(state, (draft) => {
        if (action instanceof ISetFetchingAction) {
            const { key, isFetching } = action.payload;
            draft[key] = isFetching;
        }
    });
